<div class="promo-banners-container" *ngIf="banners && banners.length > 0">
  <ng-container *ngFor="let banner of banners; let i = index; trackBy: trackById">
    <app-promo-banner
      [ngStyle]="{
        position: 'absolute',
        bottom: i * 10 + 'px',
        zIndex: 2000 - i
      }"
      [banner]="banner"
      (clickBannerAction)="onClickBannerAction($event)"
      (closeBanner)="onClose($event)"
      (doNotShowBanner)="onDoNotShowAgain($event)" />
  </ng-container>
</div>
